<template>
  <v-row>
    <v-col class="py-0" cols="12">
      <v-container class="pa-0" fluid>
        <div class="cbm-checkboxs">
          <v-checkbox
            v-for="profile in profilesPages"
            :key="profile.value"
            v-model="selectedProfiles"
            color="marca-0"
            dense
            :error="userObject.profiles ? userProfileError : profileError"
            hide-details
            single-line
            :value="profile.value"
          >
            <template v-slot:label>
              <span class="field-text">{{ profile.text }}</span>
            </template>
          </v-checkbox>
        </div>

        <div v-if="userObject.profiles">
          <div v-if="userProfileError" class="v-messages theme--light error--text mt-1" role="alert">{{ profilesErrorMessages }}</div>
        </div>
        <div v-else>
          <div v-if="profileError" class="v-messages theme--light error--text mt-1" role="alert">{{ notProfilesErrorMessages }}</div>
        </div>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import { profilesPages } from '../../mixins/user-profiles'

export default {
  name: 'AccessProfile',
  components: {},
  mixins: [profilesPages],
  props: {
    isCreateUser: {
      type: Boolean,
      default: false,
    },
    isAdminLast: {
      type: Boolean,
      default: false,
    },
    profileError: {
      type: Boolean,
      default: false,
    },
    ecommerceError: {
      type: Boolean,
      default: false,
    },
    userProfileError: {
      type: Boolean,
      default: false,
    },
    userEcommerceError: {
      type: Boolean,
      default: false,
    },
    colLength: {
      type: Number,
      default: 4,
    },
    profiles: {
      type: Array,
      required: true,
    },
    ecommerce: {
      type: Array,
      required: true,
    },
    user: {
      type: Object,
      required: false,
    },
  },
  data: () => ({
    selectedProfiles: [],
    selectedEcommerces: [],
  }),
  computed: {
    profilesErrorMessages() {
      if (this.userProfileError) return 'Campo obrigatório'
      return ''
    },
    notProfilesErrorMessages() {
      if (this.profileError) return 'Campo obrigatório'
      return ''
    },
    ecommerceErrorMessages() {
      if (this.userEcommerceError) return 'Campo obrigatório'
      return ''
    },
    notecommerceErrorMessages() {
      if (this.ecommerceError) return 'Campo obrigatório'
      return ''
    },
    userObject: {
      get() {
        return this.user
      },
      set(value) {
        this.$emit('update:user', value)
      },
    },
    profileArray: {
      get() {
        return this.profile
      },
      set(value) {
        this.$emit('update:profile', value)
      },
    },
    ecommerceArray: {
      get() {
        return this.ecommerce
      },
      set(value) {
        this.$emit('update:ecommerce', value)
      },
    },
    getEcommerce() {
      if (this.isAdminLast) {
        const newEcommerce = [].concat(this.ecommerceProfiles)
        newEcommerce.push(newEcommerce.shift())

        return newEcommerce
      }

      return this.ecommerceProfiles
    },
  },
  watch: {
    selectedProfiles() {
      this.selectedEcommerces = this.user.ecommerce ?? []
      const filteredProfiles = this.profilesPages.filter((profile) => this.selectedProfiles.includes(profile.value)) ?? []

      if (this.userObject.profiles) {
        this.userObject.profiles = filteredProfiles

        return
      }

      this.profileArray = filteredProfiles
    },
    selectedEcommerces() {
      if (this.userObject.ecommerce) {
        this.userObject.ecommerce = this.selectedEcommerces

        return
      }

      this.ecommerceArray = this.selectedEcommerces
    },
  },
  created() {
    if (this.userObject.profiles) {
      this.selectedProfiles = this.userObject.profiles.map((profile) => profile.value)

      return
    }

    this.selectedProfiles = this.profileArray.map((profile) => profile.value)
  },
  methods: {
    clearFields() {
      this.selectedProfiles = []
      this.selectedEcommerces = []
    },
  },
}
</script>

<style lang="scss">
.custom-title-font {
  color: $cinza-d10;
  font-weight: 700;
  font-size: 14px;
}

.field-text {
  font-size: 14px;
}

.cbm-checkboxs,
.ecommerce-checkboxs {
  display: grid;
  column-gap: 12px;
}

.cbm-checkboxs {
  grid-template-columns: 1fr 1fr 1fr;
}

.ecommerce-checkboxs {
  grid-template-columns: 1fr 1fr;
}
</style>
